module.exports = "/group_create-fb2bd4d1ae2959184a2d70fe1350ca5e.svg";